import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("app-theme") || "light";
  });

  const [accentColor, setAccentColor] = useState(() => {
    return localStorage.getItem("app-accent") || "indigo";
  });

  const toggleTheme = () => {
    setTheme((prev) => {
      const next = prev === "light" ? "dark" : "light";
      localStorage.setItem("app-theme", next);
      return next;
    });
  };

  const changeAccent = (color) => {
    setAccentColor(color);
    localStorage.setItem("app-accent", color);
  };

  // Sync html class for Tailwind dark mode
  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
  }, [theme]);

  return <ThemeContext.Provider value={{ theme, toggleTheme, accentColor, changeAccent }}>{children}</ThemeContext.Provider>;
};
